export default "__VITE_ASSET__C6XgQ4MN__"